import { render } from "./yearStudentsInfo.vue?vue&type=template&id=66555954&scoped=true"
import script from "./yearStudentsInfo.vue?vue&type=script&lang=js"
export * from "./yearStudentsInfo.vue?vue&type=script&lang=js"

import "./yearStudentsInfo.vue?vue&type=style&index=0&id=66555954&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66555954"

export default script